import { useRef, useState } from "react";
import { EducacionNoFormal } from "../models/JuradosModel/jurados.model";
import DocumentosService from "../api/Documentos/api-documentos";
import { openNotification } from "../utils/Notifactions";

export const useEducacionNoFormal = () => {
  const [eduacionFormalArray, setEduacionFormalArray] = useState<
    EducacionNoFormal[]
  >([]);
  const [educacionNoFormal, setEducacionNoFormal] =
    useState<EducacionNoFormal>(initialValues);

  const guardarArchivo = async (e: any) => {
    if (e.target.files[0].type === "application/pdf") {
      const formData = new FormData();
      formData.append("archivo", e.target.files[0]);
      const data = await DocumentosService.guardarArchivo(formData);
      return setEducacionNoFormal({ ...educacionNoFormal, path_anexo: data.data });
    } else {
      return openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos PDF",
        placement: "bottomRight",
      });
    }
  };

  const formRef = useRef<any>();
  const resetForm = () => {
    formRef.current.resetFields();
    setEducacionNoFormal(initialValues);
  };

  const guardarFormulario = (values: EducacionNoFormal) => {
    setEduacionFormalArray((prevState) => [...prevState, values]);
    resetForm();
  };

  return {
    educacionNoFormal,
    guardarFormulario,
    setEducacionNoFormal,
    guardarArchivo,
    formRef,
    resetForm,
    eduacionFormalArray,
    setEduacionFormalArray,
  };
};

const initialValues = {
  nombre_educacion: "",
  nombre_proceso: "",
  duracion: "",
  institucion: "",
  fecha_inicio: "",
  fecha_terminacion: "",
  numero_horas: "",
  ciudad: "",
  path_anexo: "",
};
